<template>
    <div class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="closeModal">
        <div class="modal-contents">
            <div>
                <a href="#close" title="Close" class="close" @click="closeModal">X</a>
                <h3 id="modal-title">Details</h3>
                <hr />
            </div>
            <div>
                <div class="col-sm-3"><label for="location">Location</label></div>
                <div class="col-sm-9">
                    <select class="form-control" name="location_id" v-bind:value="location_id" options="projectlocations" @change="locationCheck" required>
                        <option 
                            v-for="location in projectlocations"
                            :key="location.id"
                            :value="location.id"
                            :data-city="location.city"
                            :data-state="location.state_id"
                            :data-postal="location.postal"
                        >
                            {{location.name}}
                        </option>
                    </select>
                </div>
                <div class="col-sm-3"><label for="job_title">Job Title</label></div>
                <div class="col-sm-9">
                    <autocomplete :options="jobtitles" name="job_title" :preselect="maintitle" @select="updateJobTitle" placeholder="Search for a Job Title" required>
                        <template v-slot:item="option">
                            <p><strong>{{ option.itemname }}</strong></p>
                        </template>
                    </autocomplete>
                </div>
                <div class="col-sm-3"><label for="job_title_override">Title Override</label></div>
                <div class="col-sm-9"><input class="form-control" type="text" name="job_title_override" v-model="job_title_override" @change="updateJobTitle" placeholder="" tabindex="-1" ></div>
                <div class="col-sm-3"><label for="rate">Rate</label></div>
                <div class="col-sm-9"><input class="form-control" name="rate" v-model="rate" @change="updateRate" type="text" /></div>
                <div class="col-sm-3 m-top-10"><label for="employee_comments">Employee Comments</label></div>
                <div class="col-sm-9 m-top-10 m-bottom-10"><textarea class="form-control" name="employee_comments" rows="6" v-model="employee_comments" @change="updateEeComment" placeholder="" readonly></textarea></div>
                <div class="col-sm-3 m-top-10"><label for="employer_comments">Employer Comments</label></div>
                <div class="col-sm-9 m-top-10 m-bottom-10"><textarea class="form-control" name="employer_comments" rows="6" v-model="employer_comments" @change="updateErComment" placeholder="" ></textarea></div>
                <div class="clear"></div>
                <hr />
            </div>
            <div class="right">
                <button class="btn btn-default m-right-10" @click="closeModal">Cancel</button>
                <button class="btn btn-primary" @click="confirmModal">OK</button>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
import autocomplete from '../components/autocomplete.vue';
import {defineComponent} from 'vue';
export default defineComponent ({
    emits: ['modal-close', 'modal-confirm'],
    components: {
      autocomplete
    },

    props: {

    },

    data() {
        return {

        }
    },

    methods: {
        closeModal(event) {
            this.$emit('modal-close');
        },
        confirmModal() {
            this.$emit('modal-confirm');
            this.closeModal();
        },
    }
});
</script>
